import {
  CheckIcon,
  Divide,
  IndianRupee,
  Mail,
  PhoneIcon,
  SquareArrowOutUpRight,
  Zap,
} from "lucide-react";
import { MakePaymentProcess } from "./MakePaymentProcess";
import React, { useEffect, useRef, useState } from "react";
// import {
//   getBundleService,
//   getPackagesService,
//   getCategoryWiseService,
//   submitLead,
// } from "../pages/service/trading-investing/TradingInvesting.service";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
// import { APP_URL } from "../config/constants.config";
// import OfferBanner from "./OfferBanner";
// import "./Offer.css";
// import OffCanvasRight from "../pages/layout/interface/off-canvas-right";
// import Breadcrumbs from "./Breadcrumbs";
import { useTheme } from "../../utils/theme";
import { APP_URL } from "../../config/constants.config";
import { useDocumentTitle } from "../../utils/Common";
import { getBundleService, getPackagesService, getCategoryWiseService, submitLead } from "../../api/pricing";
import Layout from "../layout/Layout";
export default function Pricing({ path }) {
  const userDetail = useSelector((state) => state.auth.userDetail);
  const [hasPackages, setHasPackages] = useState([]);
  const [hasBundles, setHasBundles] = useState([]);
  const [CategoryWiseData, setCategoryWiseData] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [OffCanvas, setOffCanvas] = useState(false);
  const [sourceData, setSourceData] = useState("");
  const [Source, setSource] = useState("");
  const [isOpen, setIsOpen] = useState({
    showFlag: false,
    index: 0,
  });
  const [selectedOption, setSelectedOption] = useState(null);
  const [canSelectPlan, setCanSelectPlan] = useState([
    "Conservative",
    "Moderate",
    "Aggressive",
  ]);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [IsRecurringOptionOpen, setIsRecurringOptionOpen] = useState(false);
  const handleOffCanvasToggle = () => {
    setOffCanvas((prev) => false);
  };
  function handleRedirect(link) {
    navigate(link);
  }

  const { isDark, theme, isLight } = useTheme();
  useDocumentTitle(
    window.location.pathname === "/services"
      ? "Services | EquityPandit"
      : "Pricing | EquityPandit",
  );
//   useMetaDescription(
//     "Compare EquityPandit advisory plans and pricing for portfolio, multibagger, and investment research services.",
//   );

  useEffect(() => {
    if (userDetail.rpfProfileType === "Conservative")
      setCanSelectPlan(["Conservative"]);
    else if (userDetail.rpfProfileType === "Moderate")
      setCanSelectPlan(["Conservative", "Moderate"]);
    else if (userDetail.rpfProfileType === "Aggressive")
      setCanSelectPlan(["Conservative", "Moderate", "Aggressive"]);
    else if (!userDetail.rpfProfileType)
      //if rpf not filled
      setCanSelectPlan(["Conservative", "Moderate", "Aggressive"]);
  }, [userDetail.rpfProfileType]);

  // useEffect(() => {
  //   getPackagesService().then((response) => {
  //     setHasPackages(response.data.data);
  //   });
  //   getBundleService().then((response) => {
  //     setHasBundles(response);
  //   });
  // }, []);
  useEffect(() => {
    // if (window.location.pathname == "/pricing") {
    //   window.location.href= "/offers/mar-2026"
    // }
    const fetchData = async () => {
      try {
        const [packagesResponse, bundlesResponse, categoriesWiseData] =
          await Promise.all([
            getPackagesService(),
            getBundleService(),
            getCategoryWiseService(),
          ]);

        // const packages = packagesResponse.data.data;
        const packages = categoriesWiseData?.data?.data?.flatMap(
          (cat) => cat.packages || [],
        );
        const bundles = categoriesWiseData?.data?.data?.flatMap(
          (cat) => cat.bundles || [],
        );
        setHasPackages(packages);
        setHasBundles(bundles);
        setCategoryWiseData(categoriesWiseData.data.data);

        const selectedPlans = {};

        // Accumulate default selected plans for each package
        packages.forEach((item, index) => {
          const defaultPlan = item.plans
            ?.filter((plan) => plan.showHide)
            .find((plan) => plan.isDefault);

          // If a 6-month plan is found, use it; otherwise, pick the first plan
          const planToSelect = defaultPlan || item.plans?.[0];

          if (planToSelect) {
            selectedPlans[item.id] = planToSelect;
          }
        });
        bundles.forEach((item, index) => {
          const visiblePlans = item.plans?.filter((plan) => plan.showHide);
          item.plans = visiblePlans;
          // const defaultPlan = item.plans?.find((plan) => plan.duration == 6 );

          // If a 6-month plan is found, use it; otherwise, pick the first plan
          // const planToSelect = defaultPlan || item.plans?.[0];
          const planToSelect = item.plans?.[0];

          if (planToSelect) {
            selectedPlans[item.id] = planToSelect;
          }
        });

        // Set all selected plans at once to avoid overwriting
        setSelectedPlan(selectedPlans);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  const handleSelect = (option, item, index) => {
    setSelectedOption(option);
    setIsOpen({ showFlag: false, index: index });
    const newPlanToAdd = option === "" ? undefined : option;
    setSelectedPlan((prevSelectedPlan) => {
      const updatedSelectedPlan = { ...prevSelectedPlan };

      if (newPlanToAdd !== undefined) {
        if (item.bundleName) {
          updatedSelectedPlan[item.id] = {
            id: option.id,
            orderItems: [
              { name: option.bundleName, planDuration: option.duration },
            ],
            bundleName: option.bundleName,
            duration: option.duration,
            actualPrice: option.actualPrice,
            rpfType: option.rpfType,
            discountedPrice: option.discountedPrice,
            digioDescription: option.digioDescription,
          };
        } else {
          updatedSelectedPlan[item.id] = {
            ...newPlanToAdd,
            id: option.id,
            orderItems: [{ name: item?.name, planDuration: item.planDuration }],
            name: item.name,
            actualAmount: item.actualPrice,
            discount: item.discountPrice,
            rpfType: item.rpfType,
            description: item.description,
            digioDescription: item.digioDescription,
            firebaseName: item.firebaseName,
          };
        }
      } else {
        delete updatedSelectedPlan[item.id];
        setSelectedOption(null);
      }
      if (option.cfPlanId) {
        setIsRecurringOptionOpen(true);
      }
      return updatedSelectedPlan;
    });
  };

  const phoneRegExp = /^[1-9][0-9]{9}$/;
  const validationSchema = Yup.object({
    firstName: Yup.string()
      .required("Name is required")
      .max(150, "Name should be 150 characters only."),
    email: Yup.string()
      .required("Email is required")
      .max(150, "Email should be 150 characters only."),
    mobile: Yup.string()
      .required("Mobile is required")
      .matches(phoneRegExp, "Mobile number is not valid")
      .min(10, "Mobile must be 10 digits.")
      .max(10, "Mobile must be 10 digits."),
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen({ showFlag: false });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIsOpen]);

  const handleCall = () => {
    const params = {
      firstName: userDetail.firstName,
      email: userDetail.email,
      countryCode: "+91",
      mobile: userDetail.mobile,
      page: "offer",
      source: "offer-wealthx",
    };
    submitLead(params)
      .then(() => {
        alert(
          "Thank you for showing interest in our services. Our executive will contact you in 24 hours.",
        );
        window.open("https://wealth.equitypandit.in/", "_blank");
        // setTimeout(() => {
        //   setSuccessMessage("")
        // }, 10000);
      })
      .catch((e) => {
        console.error(e.response.data.message);
      });
  };
  const primaryThemeButtonClass = "btn";
  const primaryThemeButtonStyle = {
    backgroundColor: "var(--bs-emphasis-color)",
    borderColor: "var(--bs-emphasis-color)",
    color: "var(--bs-body-bg)",
  };
  const PRICINGUI = (
    <>
      {CategoryWiseData.length > 0 &&
        CategoryWiseData.map((data, idx) => {
          return (
            data.isShow && (
              <section className={``} key={idx} style={{
                backgroundColor: theme === "dark" ? "#000000" : undefined,
              }}>
                <div className="container rounded-3 py-5 pricing-page-section">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="d-flex mb-3 align-items-center flex-column">
                        <h1 className="text-body-emphasis text-capitalize text-center  fw-bold mb-3">
                          Start Your wealth creation journey
                        </h1>
                        <p className="text-center">
                          Invest with conviction using strategies built for
                          growth, stability, and opportunity.
                        </p>
                      </div>
                      <div className="row g-4 mb-4">
                        {data?.packages ? (
                          data?.packages
                            .sort((a, b) => Number(b.id) - Number(a.id))
                            .map((item, index) => {
                              const isAllowedUser = [
                                "9909905790",
                                "8460882301",
                                "7405950736",
                                "8866289676",
                              ].includes(userDetail.mobile);
                              return (
                                item.showHide &&
                                item.firebaseName !== "MIDCAP_PRO" &&
                                item.plans
                                  .filter((i) => i.platform == "ep")
                                  .filter((item) => item.showHide).length >
                                0 && (
                                  <div className={`col-md-4`} key={index}>
                                    <div
                                      className={`card border border-1 h-100 ${item.firebaseName == "EP_ALPHA_INDIA_PORTFOLIO" ? "border-warning" : item.firebaseName == "EP_MULTIBAGGER" ? "border-primary" : "border-success"} ${!isDark ? "welcome-hero-light" : "welcome-hero-dark"
                                        }`}
                                    >
                                      {/* <Link
                                        to={
                                          item.firebaseName ==
                                            "EP_ALPHA_INDIA_PORTFOLIO"
                                            ? `/${item.slug}`
                                            : `/services/${item.slug}`
                                        }
                                        onClick={handleScrollToTop}
                                        className={`${item.firebaseName == "EP_ALPHA_INDIA_PORTFOLIO" ? "bg-warning" : item.firebaseName == "EP_MULTIBAGGER" ? "bg-primary" : "bg-success"} ${isDark ? "bg-opacity-50" : "bg-opacity-25"} card-header text-start border-0 p-3 `}
                                        style={{ textDecoration: "none", color: "inherit" }}
                                      > */}
                                      <Link
                                        to={
                                          item.firebaseName === "EP_ALPHA_INDIA_PORTFOLIO"
                                            ? `/${item.slug}`
                                            : `/services/${item.slug}`
                                        }
                                        // onClick={handleScrollToTop}
                                        className="card-header text-start border-0 p-3"
                                        style={{
                                          textDecoration: "none",
                                          color: "inherit",
                                          backgroundColor:
                                            item.firebaseName === "EP_ALPHA_INDIA_PORTFOLIO"
                                              ? isDark
                                                ? "#C9A84C"   // dark theme warning
                                                : "#FFEFC3"   // light theme warning
                                              : item.firebaseName === "EP_MULTIBAGGER"
                                                ? isDark
                                                  ? "#0E6BC9"   // dark theme primary
                                                  : "#C5DDFE"   // light theme primary
                                                : isDark
                                                  ? "#198754"     // fallback (success dark - unchanged)
                                                  : "#D1E7DD",    // fallback (success light - optional)
                                        }}
                                      >
                                        <h4
                                          className={`text-black d-none text-uppercase fw-bold mt-2 mb-0 me-2`}
                                        >
                                          {item.name.toLowerCase()}{" "}
                                          {/* <SquareArrowOutUpRight
                                            className="text-dark"
                                            size={16}
                                          /> */}
                                        </h4>
                                        <img
                                          height="18"
                                          src={`/assets/ep-imgs/${item.firebaseName === "EP_ALPHA_INDIA_PORTFOLIO"
                                            ? isDark
                                              ? "portfolio_white.png"
                                              : "portfolio.png"
                                            : item.firebaseName === "EP_MULTIBAGGER"
                                              ? isDark
                                                ? "multibagger_white.png"
                                                : "multibagger.png"
                                              : "default.png"
                                            }`}
                                          alt={item.name}
                                        />
                                        <br />
                                        {/* <img height="18" src={`/ep-imgs/${item.firebaseName == "EP_ALPHA_INDIA_PORTFOLIO" ? "portfolio.png" : item.firebaseName == "EP_MULTIBAGGER" ? "multibagger.png" : "bg-success"}`} /> <br /> */}
                                        {/* <small className="">
                                          <small>{item?.subTitle}</small>
                                        </small> */}
                                        <small
                                          className="mt-2"
                                          style={{
                                            display: "block",
                                            maxWidth: "100%",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          {item?.subTitle}
                                        </small>
                                      </Link>

                                      <div className="card-body align-items-end">
                                        <div className="d-flex justify-content-between">
                                          <p className="fw-semibold">
                                            Key Features
                                          </p>
                                          {item.slug && (
                                            <Link
                                              className="text-primary text-decoration-none small"
                                              to={
                                                item.name ==
                                                  "Alpha India Portfolio"
                                                  ? `/${item.slug}`
                                                  : `/services/${item.slug}`
                                              }
                                            //   onClick={handleScrollToTop}
                                            >
                                              View Details
                                            </Link>
                                          )}
                                        </div>
                                        <div className={``}>
                                          {/* <small
                                            className={`text-muted mb-0 mt-2`}
                                          >
                                            Service Type
                                          </small>
                                          <p
                                            className={`card-text text-capitalize`}
                                          >
                                            {item.serviceType.toLowerCase()}
                                          </p> */}
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: item.description,
                                            }}
                                          ></div>
                                          {/* <div
                                              className={`text-muted d-block mt-2`}
                                            >
                                              {item.description}
                                            </div> */}
                                        </div>
                                      </div>
                                      <div className="text-center text-capitalize bg-transparent card-footer border border-0 p-0">
                                        <div className=" p-3">
                                          {/* <div className="rounded-3 px-3 py-2 bg-success bg-opacity-10"> */}
                                          {item.plans && userDetail.isActive ? (
                                            item.plans
                                              .filter((i) => i.platform == "ep")
                                              .filter(
                                                (option) => option.showHide,
                                              )
                                              .map((plan, i) => {
                                                return (
                                                  <div
                                                    className="row py-2"
                                                    key={i}
                                                  >
                                                    <div
                                                      className="col-12"
                                                      onClick={() =>
                                                        handleSelect(
                                                          plan,
                                                          item,
                                                          i,
                                                        )
                                                      }
                                                    >
                                                      {/* Radio and Duration */}
                                                      <div className="row align-items-center">
                                                        <div className="col-5">
                                                          <div className="d-flex align-items-center">
                                                            <input
                                                              type="radio"
                                                              className="me-1"
                                                              aria-label={`Select ${plan.planDuration} ${plan.planDuration >
                                                                1
                                                                ? plan.durationType
                                                                : plan.durationType ==
                                                                  "Days"
                                                                  ? "Day"
                                                                  : "Month"} plan for ${item.name}`}
                                                              checked={
                                                                selectedPlan[
                                                                  item.id
                                                                ]
                                                                  ?.planDuration ===
                                                                plan.planDuration &&
                                                                selectedPlan[
                                                                  item.id
                                                                ]
                                                                  ?.actualPrice ===
                                                                plan.actualPrice
                                                              }
                                                              onChange={() =>
                                                                handleSelect(
                                                                  plan,
                                                                  item,
                                                                  item.id,
                                                                )
                                                              }
                                                            />
                                                            {/* <small> */}
                                                            <span className="ms-2 text-capitalize">
                                                              {
                                                                plan.planDuration
                                                              }{" "}
                                                              {plan.planDuration >
                                                                1
                                                                ? plan.durationType
                                                                : plan.durationType ==
                                                                  "Days"
                                                                  ? "Day"
                                                                  : "Month"}
                                                            </span>
                                                            {/* </small> */}
                                                          </div>
                                                        </div>

                                                        {/* Price Details */}
                                                        <div className="col-7 text-end">
                                                          {plan.discountPrice ===
                                                            0 ||
                                                            plan.discountPrice ===
                                                            plan.actualPrice ? (
                                                            <>
                                                              <p className="text-body-emphasis d-block mb-0 fw-bold">
                                                                <IndianRupee
                                                                  size={15}
                                                                />
                                                                {plan.actualPrice?.toLocaleString(
                                                                  "en-IN",
                                                                )}
                                                              </p>
                                                            </>
                                                          ) : (
                                                            <>
                                                              <div className="d-flex align-items-center justify-content-end">
                                                                <s className="text-muted">
                                                                  <IndianRupee
                                                                    size={15}
                                                                  />
                                                                  {plan.actualPrice?.toLocaleString(
                                                                    "en-IN",
                                                                  )}
                                                                </s>
                                                                <span class="ms-2 fw-bold">
                                                                  <IndianRupee
                                                                    size={15}
                                                                  />
                                                                  {plan.discountPrice?.toLocaleString(
                                                                    "en-IN",
                                                                  )}
                                                                </span>
                                                              </div>
                                                            </>
                                                          )}
                                                        </div>

                                                        <div className="col-12 mt-2">
                                                          <p className="text-body-emphasis text-capitalize mb-0 ms-4 text-capitalize">
                                                            {plan.cfPlanId && (
                                                              <small>
                                                                <small className="small text-muted fst-italic">
                                                                  Auto-renews
                                                                  every month at{" "}
                                                                  <IndianRupee
                                                                    size={10}
                                                                  />
                                                                  {plan.discountPrice >
                                                                    0
                                                                    ? plan.discountPrice
                                                                    : plan.actualPrice}
                                                                  . Cancel
                                                                  anytime.
                                                                </small>
                                                              </small>
                                                            )}
                                                          </p>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                );
                                              })
                                          ) : (
                                            <></>
                                            // <div>Loading...</div>
                                          )}
                                          {/* </div> */}
                                          <div className="mt-2 ">
                                            {userDetail.isActive ? (
                                              <>
                                                <MakePaymentProcess
                                                  planData={{
                                                    [item.id]: {
                                                      id: selectedPlan[item.id]
                                                        ?.id,
                                                      orderItems: [
                                                        {
                                                          name: item?.name,
                                                          planDuration:
                                                            selectedPlan[item.id]
                                                              ?.planDuration,
                                                        },
                                                      ],
                                                      name: item?.name,
                                                      description:
                                                        item?.description,
                                                      digioDescription:
                                                        item?.digioDescription,
                                                      firebaseName:
                                                        item?.firebaseName,
                                                      actualPrice:
                                                        selectedPlan[item.id]
                                                          ?.actualPrice || 0,
                                                      rpfType: item.rpfType || 0,
                                                      discountPrice:
                                                        selectedPlan[item.id]
                                                          ?.discountPrice || 0,
                                                      pacId: item?.id,
                                                      planDuration:
                                                        selectedPlan[item.id]
                                                          ?.planDuration || 0,
                                                      durationType:
                                                        selectedPlan[item.id]
                                                          ?.durationType ||
                                                        "Months",
                                                    },
                                                  }}
                                                  componentKey={item.id}
                                                  total={
                                                    selectedPlan[item.id]
                                                      ?.discountPrice === 0
                                                      ? selectedPlan[item.id]
                                                        ?.actualPrice
                                                      : selectedPlan[item.id]
                                                        ?.discountPrice
                                                  }
                                                  gst={Math.round(
                                                    (selectedPlan[item.id]
                                                      ?.discountPrice === 0
                                                      ? selectedPlan[item.id]
                                                        ?.actualPrice
                                                      : selectedPlan[item.id]
                                                        ?.discountPrice) * 0.18,
                                                  )}
                                                  grandTotal={Math.round(
                                                    (selectedPlan[item.id]
                                                      ?.discountPrice === 0
                                                      ? selectedPlan[item.id]
                                                        ?.actualPrice
                                                      : selectedPlan[item.id]
                                                        ?.discountPrice) +
                                                    (selectedPlan[item.id]
                                                      ?.discountPrice === 0
                                                      ? selectedPlan[item.id]
                                                        ?.actualPrice
                                                      : selectedPlan[item.id]
                                                        ?.discountPrice) *
                                                    0.18,
                                                  )}
                                                  sourceData={`${item?.name}-subscribe`}
                                                  pageData={window.location.pathname
                                                    .split("/")
                                                    .filter(Boolean)
                                                    .pop()}
                                                  IsRecurringOptionOpen={
                                                    selectedPlan[item.id].cfPlanId
                                                      ? true
                                                      : IsRecurringOptionOpen
                                                  }
                                                />
                                              </>
                                            ) : (

                                              <>
                                                {/* <small>
                                                  <small className="text-center d-block">
                                                    This service is suitable only for Aggressive profile.
                                                    <br />
                                                    <a href="/risk-profile">
                                                      Reassess your risk profile
                                                    </a>
                                                  </small>
                                                </small> */}
                                                <button
                                                  className={"btn shine-effect w-100"}
                                                  style={primaryThemeButtonStyle}
                                                  onClick={() => {
                                                    setOffCanvas(true);
                                                    setSourceData(`${item?.bundleName}-subscribe`)
                                                  }}
                                                >
                                                  {" "}
                                                  View Details & Pricing{" "}
                                                </button>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                        <div className="bg-secondary bg-opacity-10 py-2">
                                          <small>
                                            <small>
                                              For any query contact{" "}
                                              <a
                                                className="text-decoration-none"
                                                href="tel:+918000816688"
                                              >
                                                {" "}
                                                <span className="text-success ms-1">
                                                  <i class="fa-solid fa-phone"></i>
                                                </span>{" "}
                                                +91 8000 816 688{" "}
                                              </a>
                                            </small>
                                          </small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              );
                            })
                        ) : (
                          <div className="col-md-12">Loading...</div>
                        )}
                        {data?.bundles ? (
                          data?.bundles
                            .filter((i) => i.platform == "ep")
                            // .sort((a, b) => Number(a.id) - Number(b.id))
                            .map((item, index) => {
                              return (
                                item.plans.filter((item) => item.showHide)
                                  .length > 0 && (
                                  <div className="col-md-4" key={index}>
                                    {/* <div
                                      className={`card h-100 rounded-3 border border-danger ${!isDark ? "welcome-hero-light" : "welcome-hero-dark"
                                        }`}
                                    >
                                      <div
                                        className="bg-danger bg-opacity-50 card-header text-start border-0 p-3"
                                      > */}
                                    <div
                                      className={`card h-100 rounded-3 ${!isDark ? "welcome-hero-light" : "welcome-hero-dark"
                                        }`}
                                      style={{
                                        border: `1px solid ${isDark ? "#6355EB" : "#6355EB"}`, // same for both
                                      }}
                                    >
                                      <div
                                        className="card-header text-start border-0 p-3"
                                        style={{
                                          backgroundColor: isDark
                                            ? "#6355EB" // dark theme bg
                                            : "#D7D3FF", // light theme bg
                                        }}
                                      >
                                        <Link
                                          to={`/wealthx`}
                                        //   onClick={handleScrollToTop}
                                          style={{ textDecoration: "none", color: "inherit" }}
                                        >
                                          <h6
                                            className={`fw-bold d-none  text-uppercase mt-2 mb-0`}
                                          >
                                            {/* <Zap className="" size={24} />{" "} */}
                                            {/* {item.bundleName.toLowerCase()} */}
                                          </h6>
                                          {/* <img height="18" src="/ep-imgs/wealthx.png" /><br /> */}
                                          <img
                                            height="18"
                                            src={isDark ? "/assets/ep-imgs/wealthx_white.png" : "/assets/ep-imgs/wealthx.png"}
                                          /><br />
                                          {/* <small className="">
                                            <small>{item?.subTitle}</small>
                                          </small> */}
                                          <small
                                            className="mt-2"
                                            style={{
                                              display: "block",
                                              maxWidth: "100%",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                            {item?.subTitle}
                                          </small>
                                        </Link>
                                      </div>
                                      <div className="card-body">
                                        <div className="d-flex justify-content-between">
                                          <p className="fw-semibold p-0">
                                            Key Features
                                          </p>

                                          <Link
                                            className="text-primary text-decoration-none small"
                                            to={`/new-wealthx`}
                                            // onClick={handleScrollToTop}
                                          >
                                            View Details
                                          </Link>

                                          {item.slug && (
                                            <Link
                                              className="text-primary text-decoration-none small"
                                              to={
                                                item.name ==
                                                  "Alpha India Portfolio"
                                                  ? `/${item.slug}`
                                                  : `/services/${item.slug}`
                                              }
                                            //   onClick={handleScrollToTop}
                                            >
                                              View Details
                                            </Link>
                                          )}
                                        </div>
                                        <div
                                        // className={`${path ? "" : "d-none"} `}
                                        >
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: item.description,
                                            }}
                                          ></div>
                                        </div>
                                      </div>
                                      <div className="text-center text-capitalize bg-transparent card-footer border border-0 p-0">
                                        <div className="p-3">
                                          {/* <div className=""> */}
                                          {item.plans && userDetail.isActive ? (
                                            item.plans
                                              .filter(
                                                (option) => option.showHide,
                                              )
                                              .map((plan, i) => {
                                                return (
                                                  <div
                                                    className="row py-2"
                                                    key={i}
                                                  >
                                                    <div
                                                      className="col-12"
                                                      onClick={() =>
                                                        handleSelect(
                                                          plan,
                                                          item,
                                                          i,
                                                        )
                                                      }
                                                    >
                                                      {/* Radio and Duration */}
                                                      <div className="row align-items-center">
                                                        <div className="col-5">
                                                          <div className="d-flex align-items-center">
                                                            <input
                                                              type="radio"
                                                              className="me-1"
                                                              aria-label={`Select ${plan.duration} ${plan.duration >
                                                                1
                                                                ? plan.durationType
                                                                : plan.durationType ==
                                                                  "Days"
                                                                  ? "Day"
                                                                  : "Month"} bundle plan for ${item.bundleName}`}
                                                              checked={
                                                                selectedPlan[
                                                                  item.id
                                                                ]
                                                                  ?.duration ===
                                                                plan.duration &&
                                                                selectedPlan[
                                                                  item.id
                                                                ]
                                                                  ?.actualPrice ===
                                                                plan.actualPrice
                                                              }
                                                              onChange={() =>
                                                                handleSelect(
                                                                  plan,
                                                                  item,
                                                                  i,
                                                                )
                                                              }
                                                            />
                                                            <span className="text-body-emphasis mb-0 ms-2 text-capitalize">
                                                              {plan.duration}{" "}
                                                              {plan.duration >
                                                                1
                                                                ? plan.durationType
                                                                : plan.durationType ==
                                                                  "Days"
                                                                  ? "Day"
                                                                  : "Month"}
                                                            </span>
                                                          </div>
                                                        </div>
                                                        {/* Price Details */}
                                                        <div className="col-7 text-end">
                                                          {plan.discountedPrice ===
                                                            0 ||
                                                            plan.discountedPrice ===
                                                            plan.actualPrice ? (
                                                            <>
                                                              <span className="fw-bold text-body-emphasis d-block">
                                                                <IndianRupee
                                                                  size={15}
                                                                />
                                                                {plan.actualPrice?.toLocaleString(
                                                                  "en-IN",
                                                                )}
                                                              </span>
                                                            </>
                                                          ) : (
                                                            <>
                                                              <div className="d-flex align-items-center justify-content-end">
                                                                <s className="text-muted">
                                                                  <IndianRupee
                                                                    size={15}
                                                                  />
                                                                  {plan.actualPrice?.toLocaleString(
                                                                    "en-IN",
                                                                  )}
                                                                </s>
                                                                <span class="ms-3 fw-bold">
                                                                  <IndianRupee
                                                                    size={15}
                                                                  />
                                                                  {plan.discountedPrice?.toLocaleString(
                                                                    "en-IN",
                                                                  )}
                                                                </span>
                                                              </div>
                                                            </>
                                                          )}
                                                        </div>
                                                        <div className="col-12 p-0">
                                                          <p className="text-body-emphasis text-capitalize mb-0 pt-0 ms-4 text-capitalize">
                                                            {plan.cfPlanId && (
                                                              <small>
                                                                <small className="small text-muted fst-italic">
                                                                  Auto-renews
                                                                  every month
                                                                  at{" "}
                                                                  <IndianRupee
                                                                    size={10}
                                                                  />
                                                                  {plan.discountedPrice >
                                                                    0
                                                                    ? plan.discountedPrice
                                                                    : plan.actualPrice}
                                                                  . Cancel
                                                                  anytime.
                                                                </small>
                                                              </small>
                                                            )}
                                                          </p>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                );
                                              })
                                          ) : (
                                            <></>
                                            // <div>Loading...</div>
                                          )}
                                          {/* </div> */}
                                          <div className="mt-3">
                                            {userDetail.isActive ? (
                                              <>
                                                <MakePaymentProcess
                                                  planData={{
                                                    [item.id]: {
                                                      id: selectedPlan[item.id]
                                                        ?.id,
                                                      orderItems: [
                                                        {
                                                          name: item?.bundleName,
                                                          planDuration:
                                                            selectedPlan[item.id]
                                                              ?.duration,
                                                        },
                                                      ],
                                                      bundleName:
                                                        item?.bundleName,
                                                      digioDescription:
                                                        item?.digioDescription,
                                                      actualPrice:
                                                        selectedPlan[item.id]
                                                          ?.actualPrice || 0,
                                                      rpfType: item.rpfType || 0,
                                                      discountedPrice:
                                                        selectedPlan[item.id]
                                                          ?.discountedPrice || 0,
                                                      duration:
                                                        selectedPlan[item.id]
                                                          ?.duration || 0,
                                                      durationType:
                                                        selectedPlan[item.id]
                                                          ?.durationType ||
                                                        "Months",
                                                    },
                                                  }}
                                                  componentKey={item.id}
                                                  total={
                                                    selectedPlan[item.id]
                                                      ?.discountedPrice === 0
                                                      ? selectedPlan[item.id]
                                                        ?.actualPrice
                                                      : selectedPlan[item.id]
                                                        ?.discountedPrice
                                                  }
                                                  gst={Math.round(
                                                    (selectedPlan[item.id]
                                                      ?.discountedPrice === 0
                                                      ? selectedPlan[item.id]
                                                        ?.actualPrice
                                                      : selectedPlan[item.id]
                                                        ?.discountedPrice) *
                                                    0.18,
                                                  )}
                                                  grandTotal={Math.round(
                                                    (selectedPlan[item.id]
                                                      ?.discountedPrice === 0
                                                      ? selectedPlan[item.id]
                                                        ?.actualPrice
                                                      : selectedPlan[item.id]
                                                        ?.discountedPrice) +
                                                    (selectedPlan[item.id]
                                                      ?.discountedPrice === 0
                                                      ? selectedPlan[item.id]
                                                        ?.actualPrice
                                                      : selectedPlan[item.id]
                                                        ?.discountedPrice) *
                                                    0.18,
                                                  )}
                                                  sourceData={`${item?.bundleName}-subscribe`}
                                                  pageData={window.location.pathname
                                                    .split("/")
                                                    .filter(Boolean)
                                                    .pop()}
                                                  IsRecurringOptionOpen={
                                                    selectedPlan[item.id].cfPlanId
                                                      ? true
                                                      : IsRecurringOptionOpen
                                                  }
                                                />
                                              </>
                                            ) : (
                                              <>
                                                {/* <small>
                                                  <small className="text-center d-block">
                                                    This service is suitable only for Aggressive profile.
                                                    <br />
                                                    <a href="/risk-profile">
                                                      Reassess your risk profile
                                                    </a>
                                                  </small>
                                                </small> */}
                                                <button
                                                  className="btn shine-effect w-100"
                                                  style={primaryThemeButtonStyle}
                                                  onClick={() => {
                                                    setOffCanvas(true);
                                                    setSourceData(`${item?.bundleName}-subscribe`)
                                                  }}
                                                >
                                                  {" "}
                                                  View Details & Pricing{" "}
                                                </button>

                                              </>
                                            )}
                                          </div>
                                        </div>
                                        <div className="bg-secondary bg-opacity-10 py-2">
                                          <small>
                                            <small>
                                              For any query contact{" "}
                                              <a
                                                className="text-decoration-none"
                                                href="tel:+918000816688"
                                              >
                                                {" "}
                                                <span className="text-success ms-1">
                                                  <i class="fa-solid fa-phone"></i>
                                                </span>{" "}
                                                +91 8000 816 688{" "}
                                              </a>
                                            </small>
                                          </small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              );
                            })
                        ) : (
                          <div className="col-md-12">Loading...</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* {OffCanvas && (
                  <div className="modal-backdrop fade show"></div>
                )}
                <OffCanvasRight
                  section="mobile"
                  sourceData={sourceData}
                  pageData={"pricing"}
                  OffCanvasToggle={handleOffCanvasToggle}
                  showModal={OffCanvas}
                /> */}
              </section>
            )
          );
        })}
      {/* <!-- 4. Delivery Method (HOW) --> */}
      <div className="py-5" style={{
        backgroundColor: theme === "dark" ? "#000000" : undefined,
      }}>

        <section
          class={`container py-5  rounded-4 shadow-lg ${!isDark ? "welcome-hero-light welcome-hero-light-border" : "welcome-hero-dark welcome-hero-dark-border"
            }`}
          id="delivery-method"
        >
          <div class="row justify-content-center align-items-center">
            <div class="col-lg-8 text-center text-lg-start p-4">
              <h2 class="fw-bold mb-3 text-body-emphasis">Real-Time Delivery: Your Exclusive App</h2>
              <p class="text-muted mb-4">
                All your premium recommendations are delivered instantly and
                securely via the official EquityPandit App (Android & iOS).
              </p>

              <ul class="list-unstyled text-start">
                <li class="d-flex align-items-center mb-2 fw-semibold">
                  <i class="fa fa-bell text-success me-2"></i> Instant Alerts
                </li>
                <li class="d-flex align-items-center mb-2 fw-semibold">
                  <i class="fa fa-clock text-success me-2"></i> Timely Entry &
                  Exit{" "}
                </li>
                <li class="d-flex align-items-center mb-2 fw-semibold">
                  <i class="fa fa-lock text-success me-2"></i> Secure & Private
                  Access
                </li>
                <li class="d-flex align-items-center mb-2 fw-semibold">
                  <i class="fa fa-mobile text-success me-2"></i> Available on
                  android and iOS both
                </li>
              </ul>
            </div>

            <div class="col-md-3 col-8 text-center mt-4 mt-lg-0">
              {/* <!-- Placeholder for a high-quality mobile app mockup image --> */}
              {/* <img src="https://equitypandit.in/assets/img/mobile-app7.png" class="img-fluid rounded-4 shadow-2xl border border-white" alt="Mobile App Display" /> */}
              <img
                src={`${APP_URL}/assets/img/mobile-app9.png`}
                class="img-fluid rounded-4 shadow-2xl "
                alt="Mobile App Display"
              />
            </div>
          </div>
        </section>
      </div>
      {/* {userDetail?.isActive ?
        <div className="container" >
          <div className="row justify-content-center" >
            <div className="col-md-12">
              <div className="grd-dark shine-effect rounded-3 text-center p-3 py-5 w-100">
                <div className="badge bg-warning d-none">
                  Newly Launched
                </div>
                <div className="text-white fst-italic fs-4 text-capitalize mb-3">
                  Build Exponential Wealth with
                </div>
                <h1 className="fw-bold display-5 my-2"><span className="color-text fst-italic"> WealthX </span></h1>
                <div className="text-white text-capitalize fs-5 mt-3">
                  <small>A 10-years Premium Membership to build massive wealth.</small>
                </div>
                <button className="btn glare mt-3 text-white" onClick={() => handleCall()} > Get More Details</button>
              </div>
            </div>
          </div>
        </div>
        :
        <div className="conatiner">
          <div className="col-md-10 m-auto">
            <div className="grd-dark shine-effect px-3 py-5 w-100">
              <div className="row align-items-center justify-content-center">
                <div className="col-md-7 text-center text-md-start">
                  <div className="p-3">
                    <div className="badge bg-warning d-none">
                      Newly Launched
                    </div>
                    <div className="text-white fst-italic fs-4 text-capitalize mb-3 ">
                      Build Exponential Wealth with
                    </div>
                    <h1 className="fw-bold display-3 my-2"><span className="color-text fst-italic"> WealthX </span></h1>
                    <div className="text-white text-capitalize fs-5 mt-3">
                      <small>A 10-years Premium Membership to build massive wealth.</small>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="rounded-3 bg-black p-3">
                    <Formik
                      initialValues={{
                        firstName: "",
                        email: "",
                        countryCode: "+91",
                        mobile: "",
                        page: "offer",
                        source: "offer-wealthx",
                      }}
                      validationSchema={validationSchema}
                      onSubmit={(values, { setSubmitting, resetForm }) => {
                        resetForm();
                        setSubmitting(true);
                        submitLead(values)
                          .then((res) => {
                            alert("Thank you for showing interest in our services. Our executive will contact you in 24 hours.");
                            window.open("https://wealth.equitypandit.in/", "_blank");
                          })
                          .catch((e) => {
                            console.error(e.response.data.message);
                          });
                      }}
                      enableReinitialize
                    >
                      {({ isSubmitting, touched, errors, values }) => (
                        <Form className="mx-md-4 my-md-3">
                          <div className="row">
                            <div className="col-12 text-center">
                              <p className="mb-0" >Know More About</p>
                              <h4 className="fw-bold color-text"> WealthX</h4>
                            </div>
                            <div className="col-12 mt-3">
                              <Field
                                name="firstName"
                                placeholder="Name*"
                                className={`form-control rounded-3 py-2 px-3 show-tick ${touched.firstName && errors.firstName
                                  ? "is-invalid"
                                  : "border-dark-subtle"
                                  }`}
                                value={values.firstName}
                              />
                              <ErrorMessage
                                name="firstName"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                            <div className="col-12 mt-3">
                              <Field
                                name="email"
                                placeholder="Email*"
                                className={`form-control rounded-3 py-2 px-3 show-tick ${touched.email && errors.email
                                  ? "is-invalid"
                                  : "border-dark-subtle"
                                  }`}
                                value={values.email}
                              />
                              <ErrorMessage
                                name="email"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                            <div className="col-12 mt-3">
                              <Field
                                name="mobile"
                                placeholder="Mobile*"
                                className={`form-control rounded-3 py-2 px-3 show-tick ${touched.mobile && errors.mobile
                                  ? "is-invalid"
                                  : "border-dark-subtle"
                                  }`}
                                value={values.mobile}
                              />
                              <ErrorMessage
                                name="mobile"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                            {/* {successMessage && (
                                <div className="text-center mt-2 text-success">
                                  <small>
                                    <b>{successMessage}</b>
                                  </small>
                                </div>
                              )} */}

      {/* {failedMessage && (
                                <div className="text-center mt-2 text-danger">
                                  <small>
                                    <b>{failedMessage}</b>
                                  </small>
                                </div>
                              )}

                            <div className="col-12">
                              <div className="text-center my-lg-0 my-2">
                                <button
                                  type="submit"
                                  disabled={isSubmitting}
                                  className="btn btn-default text-white glare mt-3"
                                >
                                  Get More Details
                                </button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      } */}
    </>
  );
  return (
    <>
      {/* {path == "/services/trading-investing" || path == "/dashboard" ? ( */}
        <Layout>
        {PRICINGUI}
        </Layout>
      {/* ) : (
          <Breadcrumbs
            items={[{ label: "Pricing", path: "/pricing" }]}
            pageName="Pricing"
            description="Compare EquityPandit advisory plans and pricing for portfolio, multibagger, and investment research services."
          />
          {PRICINGUI}
      )} */}
    </>
  );
}
